import { Box, IconButton, Typography } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useNavigate } from "react-router-dom";

import { Stack } from "@mui/system";

import store from "../../mobx";
import { Facebook, Instagram, Twitter } from "@mui/icons-material";

const WHITE = "#FFF";

export const Footer = observer(function Footer() {
  const navigate = useNavigate();

  const items = [
    {
      Icon: Facebook,
      src: "https://www.facebook.com/profile.php?id=100054328218293",
    },
    {
      Icon: Twitter,
      src: "https://www.facebook.com/profile.php?id=100054328218293",
    },
    {
      Icon: Instagram,
      src: "https://www.facebook.com/profile.php?id=100054328218293",
    },
  ];

  const { isPhone } = store.mediaBreakpointStore;

  return (
    <Stack
      direction="row"
      width="100%"
      justifyContent="center"
      spacing={2}
      sx={{ bgcolor: "#111" }}
    >
      {items.map(({ Icon, src }, index) => (
        <IconButton key={index} component="a" href={src} target="_blank">
          <Icon
            sx={isPhone ? { height: 32, width: 32 } : { height: 36, width: 36 }}
          />
        </IconButton>
      ))}
    </Stack>
  );
});
